import ContentBlocksModel from '#model/ContentBlocksModel'
import { useApiClient } from '#context/ApiContext'
import { useNotifications } from '#context/NotificationContext'
import { useInstanceOf } from 'eilmer-mvvm/react'

export default class ContentBlocksViewModel {

  constructor(apiClient, notificationsProvider, websiteId) {
    this.model = new ContentBlocksModel(apiClient)
    this.notifications = notificationsProvider
    this.entity = new ContentBlocksModel.ContentBlock()
    this.websiteId = websiteId
    this.editing = false
    this.loadEntities()
  }

  async loadEntities() {
    try {
      this.entities = await this.model.getContentBlocks(this.websiteId)
    } catch (err) {
      console.error(err)
      this.notifications.error(err.message)
    }
  }

  doEditEntity(entity) {
    const editingEntity = entity || {website_id: this.websiteId}
    this.entity = new ContentBlocksModel.ContentBlock(editingEntity)
    this.editing = true
  }

  doCancelEdit() {
    this.editing = false
  }

  async doSaveEntity(entity) {
    try {
      if (entity.isNew()) {
        const result = await this.model.createContentBlock(entity)
        this.editing = false
        this.loadEntities()
        return result
      } else {
        const result = await this.model.updateContentBlock(entity)
        this.editing = false
        this.loadEntities()
        return result
      }
    } catch (err) {
      console.error(err)
      this.notifications.error(err.message)
    }
  }

  async doDeleteEntity(entity) {
    if (await this.notifications.confirm('Are you sure you\'d like to delete this item?')) {
      try {
        const result = await this.model.deleteContentBlock(entity)
        this.loadEntities()
        return result
      } catch (err) {
        console.error(err)
        this.notifications.error(err.message)
      }
    }
  }

  get fields() {
    return [
      { key: 'content_block_id', label: "ID", _style: { width: '6%'}, _classes: 'bg-light text-dark' },
      { key: 'website', _style: { width: '30%'} },
      { key: 'block', _style: { width: '25%'} },
      { key: 'group_name', _style: { width: '25%'} },
      {
        key: 'actions',
        label: '',
        _style: { width: '70px' },
        filter: false
      }
    ]
  }

}

ContentBlocksViewModel.useInstance = function(websiteId) {
  return useInstanceOf(ContentBlocksViewModel, useApiClient(), useNotifications(), websiteId)
}
